import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection14Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/npx9sgfggt`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection14Video;
